import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';

export function PageLoader() {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen flex items-center justify-center bg-earth-50">
      <motion.div
        initial={{ opacity: 0, scale: 0.9 }}
        animate={{ opacity: 1, scale: 1 }}
        className="flex flex-col items-center gap-4"
      >
        <div className="w-16 h-16 bg-brand-600 rounded-2xl flex items-center justify-center animate-pulse">
          <span className="text-white font-display font-bold text-3xl">M</span>
        </div>
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2 }}
          className="text-earth-600 font-medium"
        >
          {t('common.loading', 'Yükleniyor...')}
        </motion.div>
      </motion.div>
    </div>
  );
}

export default PageLoader;
